/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountBookApiResponseLong } from '../models/AccountBookApiResponseLong';
import type { AccountBookApiResponseUserSettingsResponse } from '../models/AccountBookApiResponseUserSettingsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AccountBookPendingTransactionService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 자동수집 미확정 거래 개수 조회
   * 현재 인증 사용자의 활성 자동수집 미확정 거래 개수를 조회합니다.
   * @returns AccountBookApiResponseLong OK
   * @throws ApiError
   */
  public countPendingTransactions(): CancelablePromise<AccountBookApiResponseLong> {
    return this.httpRequest.request({
      method: 'GET',
      url: `/vab-v2/pending-transactions/count`,
    });
  }
  /**
   * 차계부 설정 조회
   * 사용자별 알림 및 차계부 설정을 조회합니다.
   * @returns AccountBookApiResponseUserSettingsResponse OK
   * @throws ApiError
   */
  public getSettings(): CancelablePromise<AccountBookApiResponseUserSettingsResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: `/vab-v2/settings`,
    });
  }
}
